/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Typography} from 'onboarding-components';
import clsx from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';

import styles from '../index.module.styl';

type HeaderProps = {
  imgSrc: string;
  title: string;
  step: string;
  duration?: number;
  completed?: boolean;
};

export const Header = ({imgSrc, title, step, duration, completed}: HeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <img src={imgSrc} height={60} />
        <div>
          <Typography variant='eyebrowSm' className={styles.step}>
            {step}
          </Typography>
          <Typography variant='headingSm' style={{margin: 0}}>
            {title}
          </Typography>
        </div>
      </div>
      <Typography variant='bodySm' className={clsx(styles.time, {[styles.completed]: completed})}>
        {completed ? (
          <>
            <SvgIconReact icon={`checkmark`} color={`#07B096`} />
            {`Completed`}
          </>
        ) : (
          duration && <div>{duration === 1 ? `1 minute` : `${duration} minutes`}</div>
        )}
      </Typography>
    </div>
  );
};
